import { render, staticRenderFns } from "./chat-content.vue?vue&type=template&id=047a7e9f&scoped=true"
import script from "./chat-content.vue?vue&type=script&lang=js"
export * from "./chat-content.vue?vue&type=script&lang=js"
import style0 from "./chat-content.vue?vue&type=style&index=0&id=047a7e9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047a7e9f",
  null
  
)

export default component.exports